import {
  CountryRoute,
  CurrencyRoute,
  DefaultProvider,
  RouteTransfer,
} from '@/types/RouteTransferType';

export const valuesCurrencyRoute: CurrencyRoute = {
  id: '',
  code: '',
  name: '',
};

export const valuesCountryRoute: CountryRoute = {
  id: 0,
  nameEN: '',
  nameES: '',
  flag: '',
  dialCode: '',
  areaCode: '',
  isoCode: '',
  alpha2Code: 'CL',
  statusCard: false,
  enabled: false,
  priority: 0,
  cardTermsAndConditions: null,
  walletEnabled: false,
  currencyCode: '',
  walletPartner: '',
  walletEnabledMobile: false,
  particularTermCondition: false,
  walletCurrencyCode: '',
  states: [],
};

export const valuesRouteTransfer: RouteTransfer = {
  country: valuesCountryRoute,
  currency: valuesCurrencyRoute,
  id: 0,
  minUSD: '',
  maxUSD: '',
  canSend: '',
  canReceive: '',
  defaultAmount: '',
  originMaxUSD: '',
  originMinUSD: '',
  maxOriginAmount: '',
  minOriginAmount: '',
  destinationRestriction: [],
  minDestinyAmount: '',
  maxDestinyAmount: '',
  originFXCostPercentage: '',
  originOperationalCostFixed: '',
  defaultDestinyRoute: '',
  emailLanguage: '',
  originMarkup: 0,
  depositBanks: [],
  destinyBanks: [],
  defaultProvider: {} as DefaultProvider,
  defaultLanguage: '',
  routingTypes: [],
  postCode: '',
  byProvider: '',
  timeGuaranteedRateH: '',
  timeOfferedTransferH: '',
  originDisclaimerStatus: false,
  originDisclaimerText: '',
  destinyDisclaimerStatus: false,
  destinyDisclaimerText: '',
  documentIdIndividualTypes: [],
  documentIdCompanyTypes: [],
  defaultRoute: false,
  originAcknowledgmentStatus: false,
  originAcknowledgmentText: '',
  originAcknowledgmentThreshold: 0,
  destinyAcknowledgmentStatus: false,
  destinyAcknowledgmentText: '',
  destinyAcknowledgmentThreshold: 0,
};
